import { useEffect, useState } from "react";
import ModalBase from "../../../global/ModalBase";
import { TVuelosStyle } from "./styles"
import { useDispatch, useSelector } from "react-redux";
import HeaderModal from "../../../global/headerModal";
import { Button, Grid } from "@material-ui/core";
import BackDrop from "../../../global/BackDrop";
import TablaVuelos from "./TablaVuelos";
import { closeModalVuelos } from "../../../ducks/proveedorTerrestreDuck";
import FProveedoresVuelos from "../FProveedorVuelos";
import { obtenerVuelosPorCircuitoAction } from "../../../ducks/proveedorAereolineaDuck";
import { offLoadAction, onLoadAnction } from "../../../ducks/loadDuck";

const TVuelos = () => {
    const classes = TVuelosStyle();
    const dispatch = useDispatch();
    const [isLoad, setIsload] = useState(false);
    const { openVuelo, circuitoSelect } = useSelector(store => store.proveedorTerrestre);
   
    const handleClose = () => {
        dispatch(closeModalVuelos())
    }

    useEffect(() => {
        setIsload(true)
        dispatch(onLoadAnction({ message: "" }))    
        dispatch(obtenerVuelosPorCircuitoAction({idPaqueteCircuito: circuitoSelect?.ClaveCircuito}))
        .then(Response => {
            dispatch(offLoadAction())
        }).finally(() => {
            setIsload(false)
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [circuitoSelect?.ClaveCircuito])

    return (
        <ModalBase classes={classes} open={openVuelo} onClose={handleClose}>
            <HeaderModal
                titulo={`Vuelo para el paquete ${circuitoSelect?.ClaveCircuito}`}
                handleClose={handleClose}
            />

            <Grid container className={classes.containerSpacing}>
                <Grid item xs={12} className={classes.proveedor}>
                    <FProveedoresVuelos circuito={circuitoSelect} />
                </Grid>
                <Grid item xs={12}>
                    <TablaVuelos />
                </Grid>
            </Grid>

            <Grid container className={classes.containerSpacing}>
                <Grid item xs={12} className={classes.modalBotonesCenter}>
                    <Button
                        onClick={handleClose}
                        variant="contained"
                        color="primary"
                        className={classes.modalBoton}
                    >
                    Confirmar
                    </Button>
                </Grid>
            </Grid>
            <BackDrop open={isLoad} />
        </ModalBase>
    )
}

export default TVuelos